import * as React from 'react';
import NotesMediaRow from './NotesMediaRow';
import { NoteMediaItem } from '../../utils/NoteMediaUtils';

interface NotesMediaListProps {
	items: NoteMediaItem[];
}

/** The card that holds the Files / Links rows; each row draws the divider above itself. */
const NotesMediaList: React.FC<NotesMediaListProps> = ({ items }) => (
	<div className="overflow-hidden rounded-lg bg-white">
		{items.map((item) => (
			<NotesMediaRow key={item.key} item={item} />
		))}
	</div>
);

export default NotesMediaList;
